import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PageTitle from 'components/page-title';
import ShareLink from 'components/share-link';
import { fetchUserRegistrationLinkAsync, getUserRegistrationLinkData } from 'store/user-registration-link';
import { Dictionary } from 'utils/constants/dictionary';
import { useAppDispatch } from 'utils/hooks';
import './ProfileInvitation.scss';

const ProfileInvitation = (): JSX.Element => {
	const dispatch = useAppDispatch();
	const link = useSelector(getUserRegistrationLinkData);

	useEffect(() => {
		dispatch(fetchUserRegistrationLinkAsync());
	}, [dispatch]);

	return (
		<div className="profile-invitation">
			<PageTitle backLink="/profile" />

			<div className="profile-invitation__wrap">
				<h2>
					<FormattedMessage
						defaultMessage="Invite. Coach. Earn"
						id={Dictionary.profileInvitations.inviteCoachEarn}
					/>
				</h2>
				<ShareLink btnTextId={Dictionary.common.copy} link={link || ''} showHelper={false} />
				<div className="profile-invitation__text">
					<FormattedMessage
						defaultMessage="Invite new users to the platform and increase your income."
						id={Dictionary.profileInvitations.text}
					/>
				</div>
			</div>
		</div>
	);
};

export default ProfileInvitation;
